import { OnyxDocument } from './types'

import SourceBadge from './source-badge'

export default function SourceLink(document: OnyxDocument) {
  const { semantic_identifier, link, match_highlights } = document
  let matchHighlight = match_highlights.find((highlight) => highlight.includes('<hi>'))
  const matchHighlightIndex = matchHighlight?.indexOf('<hi>')
  if (matchHighlightIndex && matchHighlightIndex >= 52) {
    matchHighlight = `...${matchHighlight?.slice(matchHighlightIndex - 32)}`
  }
  let highlightedText = matchHighlight?.split(/<\/?hi>/g).map((part, index) =>
    index % 2 === 0 ? (
      part
    ) : (
      <mark key={index} className="bg-yellow-200">
        {part}
      </mark>
    )
  )

  return (
    <a
      href={link}
      className="overflow-hidden flex flex-col gap-0.5 rounded-lg px-3 py-2 flex-shrink-0 bg-secondary-50 hover:bg-secondary-200 text-indigoBlue dark:bg-secondary-700 dark:hover:bg-secondary-600 dark:text-white transition-colors"
      target="_blank"
      rel="noreferrer noopener"
    >
      <SourceBadge document={document} />
      <div className="line-clamp-1 font-semibold text-ellipsis h-6 text-base">{semantic_identifier}</div>
      {highlightedText && (
        <div className="line-clamp-2 text-sm font-normal leading-snug [&_*]:!text-sm mt-1">{highlightedText}</div>
      )}
    </a>
  )
}
